import React, { FC, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Grid, Link } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import ClearIcon from '@material-ui/icons/Clear'
import DeleteDialog from './DeleteDialog'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import clsx from 'clsx'
import { BiTubeProduct, BitubeProperties } from '../../BiTube/enum'
import { biTubeConfigContext } from '../BiTube'
import { getOverhangDisplayValue } from '@src/routes/Configurators/components/OptionalModifications/ModificationResponse'
import { checkValidKey } from '@src/routes/Configurators/utils/util'

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    minHeight: 325,
    overflow: 'hidden',
    '& .MuiDialogContent-root': {
      maxHeight: theme.spacing(109),
    },
    '& .MuiTableCell-root': {
      padding: theme.spacing(1.75, 1.25),
    },
  },
  buttonWrapper: {
    justifyContent: 'flex-start',
    padding: theme.spacing(2, 6),
  },
  clearButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  table: {
    minWidth: 900,
  },
  title: {
    backgroundColor: theme.palette.background.grey,
  },
  rootRow: {
    color: '#787878',
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  rootRowName: {
    color: '#787878',
    fontWeight: theme.typography.fontWeightMedium,
    paddingRight: theme.spacing(1),
  },
  deleteAll: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.primary.main,
    margin: 0,
    padding: 0,
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
  },
  delPopup: {
    height: 0,
  },
  overFlowX: {
    overflowX: 'hidden',
  },
  seqWordWrap: {
    width: 270,
    wordBreak: 'break-all',
    paddingLeft: theme.spacing(1),
  },
  amountWidth: {
    width: 148,
    wordBreak: 'break-all',
    paddingLeft: theme.spacing(1),
  },
  labelRoot: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey[500],
  },
  amountLeftPadding: {
    paddingLeft: theme.spacing(1),
  },
  deleteButton: {
    paddingTop: theme.spacing(0),
  },
  nameWordWrap: {
    width: 145,
    wordBreak: 'break-all',
    color: theme.palette.primary.main,
  },
  deleteIcon: {
    fontSize: theme.typography.pxToRem(22),
    color: theme.palette.grey[400],
  },
  errorRow: {
    '& td:first-child > div': {
      borderLeft: `8px solid ${theme.palette.rich.red}`,
      marginLeft: theme.spacing(-1.25),
    },
    '& ~ $noErrorRow .MuiGrid-container.MuiGrid-spacing-xs-5 a': {
      marginLeft: theme.spacing(3.5),
    },
  },
  viewAllRow: {
    '& .MuiGrid-spacing-xs-5 > .MuiGrid-item': {
      padding: theme.spacing(3, 2.5, 0, 2.5),
    },
    '& .MuiGrid-spacing-xs-5 > .MuiGrid-item:last-child': {
      paddingBottom: theme.spacing(2.5),
    },
  },
  noErrorRow: {},
  activeLabel: {},
}))

interface ViewAllDialogProps {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  viewAllItems: any[]
  productName: string
  setActive: React.Dispatch<React.SetStateAction<any>>
  onDelete: any
}

let delAllFlag = false
export function deleteAll() {
  delAllFlag = true
}
let data
let closeViewAll = false

//function for deleting selected items in from view all popup
export function performDeleteViewAll(obj) {
  const array = data
  const index = array.indexOf(obj)
  if (index !== -1) {
    array.splice(index, 1)
    data = [...array]
    if (data.length === 0) {
      // if all the elements are deleted close the pop up
      closeViewAll = true
    }
  }
}
const ViewAllDialog: FC<ViewAllDialogProps> = (props) => {
  const classes = useStyles()
  const {
    dialogOpen,
    setDialogOpen,
    viewAllItems,
    setActive,
    onDelete,
    productName,
  } = props
  data = viewAllItems
  const handleClose = () => {
    setDialogOpen(false)
  }
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)

  if (delAllFlag === true) {
    data = []
    setDialogOpen(false)
    biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    delAllFlag = false
  }
  const change = (id) => {
    setActive(id)
    handleClose()
  }
  // if all the elements are deleted close the pop up
  if (closeViewAll === true) {
    setDialogOpen(false)
  }

  let isError = true
  const isValidSeq = (row) => {
    isError = true

    if (row.listError) {
      row.listError.forEach((object) => {
        if (
          object.key === BitubeProperties.SequenceKey ||
          object.key === BitubeProperties.AntiSequenceKey
        ) {
          isError = false
        }
      })
    }
    return isError
  }
  const [delDialogOpen, setDelDialogOpen] = useState(false)
  const [delItem, setDelItem] = useState()
  const [delType, setDelType] = useState('')
  const renderData = () => {
    const result: any[] = []
    data.forEach((row, index) => {
      let errorBar = false
      if (row.listError) {
        row.listError.forEach((err) => {
          if (
            err.key &&
            err.key !== '' &&
            err.key !== BitubeProperties.ReviewError
          ) {
            errorBar = true
          }
        })
      }
      const duplexComponent = () => {
        if (isValidSeq(row)) {
          if (
            productName === BiTubeProduct.Duplex ||
            productName === BiTubeProduct.mirna
          ) {
            return (
              <Grid item xs={12}>
                {row.fiveMod !== BitubeProperties.None ? row.fiveMod : ''}{' '}
                {row.sequence.length !== 0 ? row.sequence : ''}
                {row.sequence.length !== 0
                  ? row.customerOverhang !== BitubeProperties.None
                    ? getOverhangDisplayValue(
                        bitubeState.specificationResponse,
                        row.customerOverhang
                      )
                    : ''
                  : ''}
                {row.threeMod !== BitubeProperties.None ? row.threeMod : ''}
              </Grid>
            )
          } else {
            return (
              <Grid item xs={12}>
                {row.sequence.length !== 0 ? row.sequence : ''}
                {row.sequence.length !== 0
                  ? row.customerOverhang !== BitubeProperties.None
                    ? getOverhangDisplayValue(
                        bitubeState.specificationResponse,
                        row.customerOverhang
                      )
                    : ''
                  : ''}
              </Grid>
            )
          }
        } else {
          return (
            <Grid item xs={12}>
              {'--'}
            </Grid>
          )
        }
      }

      const AntiDuplexComponent = () => {
        if (isValidSeq(row)) {
          if (
            productName === BiTubeProduct.Duplex ||
            productName === BiTubeProduct.mirna
          ) {
            return (
              <Grid item xs={12}>
                {row.antisenceFiveMod !== BitubeProperties.None
                  ? row.antisenceFiveMod
                  : ''}
                {row.antisenceSequence.length !== 0
                  ? row.antisenceSequence
                  : ''}
                {row.antisenceSequence.length !== 0
                  ? row.customerAntisenseOverHang !== BitubeProperties.None
                    ? getOverhangDisplayValue(
                        bitubeState.specificationResponse,
                        row.customerAntisenseOverHang
                      )
                    : ''
                  : ''}
                {row.antisenceThreeMod !== BitubeProperties.None
                  ? row.antisenceThreeMod
                  : ''}
              </Grid>
            )
          } else {
            return (
              <Grid item xs={12}>
                {row.antisenceSequence.length !== 0
                  ? row.antisenceSequence
                  : ''}
                {row.antisenceSequence.length !== 0
                  ? row.customerAntisenseOverHang !== BitubeProperties.None
                    ? getOverhangDisplayValue(
                        bitubeState.specificationResponse,
                        row.customerAntisenseOverHang
                      )
                    : ''
                  : ''}
              </Grid>
            )
          }
        } else {
          return (
            <Grid item xs={12}>
              {'--'}
            </Grid>
          )
        }
      }
      result.push(
        <TableRow
          key={index}
          className={clsx(
            classes.viewAllRow,
            errorBar ? classes.errorRow : classes.noErrorRow
          )}
        >
          <TableCell align="left">
            {productName === BiTubeProduct.mirna ? (
              <Grid container spacing={5} className={classes.nameWordWrap}>
                <Grid item xs={12}>
                  {row.antisenceName ? (
                    <Link
                      href="#"
                      underline="hover"
                      onClick={() => change(index)}
                      className={clsx(classes.labelRoot && classes.activeLabel)}
                    >
                      <strong>{row.antisenceName}</strong>
                    </Link>
                  ) : (
                    '--'
                  )}
                </Grid>
                <Grid item xs={12}>
                  {row.name ? (
                    <Link
                      href="#"
                      underline="hover"
                      onClick={() => change(index)}
                      className={clsx(classes.labelRoot && classes.activeLabel)}
                    >
                      <strong>{row.name}</strong>
                    </Link>
                  ) : (
                    '--'
                  )}
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={5} className={classes.nameWordWrap}>
                <Grid item xs={12}>
                  {row.name ? (
                    <Link
                      href="#"
                      underline="hover"
                      onClick={() => change(index)}
                      className={clsx(classes.labelRoot && classes.activeLabel)}
                    >
                      <strong>{row.name}</strong>
                    </Link>
                  ) : (
                    '--'
                  )}
                </Grid>
                <Grid item xs={12}>
                  {row.antisenceName ? (
                    <Link
                      href="#"
                      underline="hover"
                      onClick={() => change(index)}
                      className={clsx(classes.labelRoot && classes.activeLabel)}
                    >
                      <strong>{row.antisenceName}</strong>
                    </Link>
                  ) : (
                    '--'
                  )}
                </Grid>
              </Grid>
            )}
          </TableCell>
          <TableCell align="left" className={classes.seqWordWrap}>
            <Grid container spacing={5}>
              {productName === BiTubeProduct.mirna ? (
                <>
                  {AntiDuplexComponent()}
                  {duplexComponent()}{' '}
                </>
              ) : (
                <>
                  {duplexComponent()}
                  {AntiDuplexComponent()}
                </>
              )}
            </Grid>
          </TableCell>
          <TableCell align="left">
            <Grid container spacing={5}>
              <Grid item xs={8}>
                {productName === BiTubeProduct.mirna
                  ? isValidSeq(row) && row.antisenceBaseCount !== 0
                    ? row.antisenceBaseCount
                    : '--'
                  : isValidSeq(row) && row.baseCount !== 0
                    ? row.baseCount
                    : '--'}
              </Grid>
              <Grid item xs={8}>
                {productName === BiTubeProduct.mirna
                  ? isValidSeq(row) && row.baseCount !== 0
                    ? row.baseCount
                    : '--'
                  : isValidSeq(row) &&
                      row.sequence.length !== 0 &&
                      row.antisenceSequence.length !== 0
                    ? row.antisenceBaseCount
                    : '--'}
              </Grid>
            </Grid>
          </TableCell>
          <TableCell align="left" className={classes.amountWidth}>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                {row.amount?.length ? (
                  <FormattedMessage
                    {...checkValidKey(
                      messages[
                        `_PC_SPEC_${row.amount}`.replace(/[^a-zA-Z0-9]/g, '_')
                      ],
                      `_PC_SPEC_${row.amount}`.replace(/[^a-zA-Z0-9]/g, '_')
                    )}
                  />
                ) : (
                  '--'
                )}
              </Grid>
              <Grid item xs={12}>
                {row.amount?.length ? (
                  <FormattedMessage
                    {...checkValidKey(
                      messages[
                        `_PC_SPEC_${row.amount}`.replace(/[^a-zA-Z0-9]/g, '_')
                      ],
                      `_PC_SPEC_${row.amount}`.replace(/[^a-zA-Z0-9]/g, '_')
                    )}
                  />
                ) : (
                  '--'
                )}
              </Grid>
            </Grid>
          </TableCell>
          <TableCell align="left" className={classes.amountLeftPadding}>
            <Grid container spacing={5}>
              <Grid item xs={8}>
                {row.purification?.length ? (
                  <FormattedMessage
                    {...checkValidKey(
                      messages[`_PC_SPEC_${row.purification}`],
                      `_PC_SPEC_${row.purification}`
                    )}
                  />
                ) : (
                  '--'
                )}
              </Grid>
              <Grid item xs={8}>
                {row.purification?.length ? (
                  <FormattedMessage
                    {...checkValidKey(
                      messages[`_PC_SPEC_${row.purification}`],
                      `_PC_SPEC_${row.purification}`
                    )}
                  />
                ) : (
                  '--'
                )}
              </Grid>
            </Grid>
          </TableCell>
          <TableCell align="left">
            <Grid container spacing={5}>
              <Grid item xs={8}>
                {row.tubes.length !== 0 ? row.tubes : '--'}
              </Grid>
              <Grid item xs={8}>
                {row.tubes.length !== 0 ? row.tubes : '--'}
              </Grid>
            </Grid>
          </TableCell>
          <TableCell align="left" className={classes.deleteButton}>
            <Grid container spacing={5}>
              <Grid item xs={8}>
                <IconButton
                  aria-label="delete"
                  onClick={() => {
                    setDelDialogOpen(true)
                    setDelItem(row)
                    setDelType('SelectedViewAll')
                  }}
                >
                  <DeleteIcon className={classes.deleteIcon} />
                </IconButton>
              </Grid>
              <Grid item xs={8}></Grid>
            </Grid>
          </TableCell>
        </TableRow>
      )
    })

    return result
  }
  return (
    <Dialog
      onClose={handleClose}
      aria-label="Are you sure you want to clear items?"
      open={dialogOpen}
      maxWidth="md"
      classes={{ paperScrollPaper: classes.dialog }}
    >
      <DialogTitle className={classes.title}>
        <FormattedMessage
          {...messages.CONF_VIEW_ALL_TOTAL_OLIGOS}
          values={{ noOfOligos: data.length }}
        />
      </DialogTitle>
      <IconButton
        className={classes.clearButton}
        color="primary"
        onClick={handleClose}
      >
        <ClearIcon />
      </IconButton>
      <DialogContent className={classes.overFlowX}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell align="left" className={classes.rootRowName}>
                <FormattedMessage {...messages.NAME} />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}>
                {productName === BiTubeProduct.mirna ? (
                  <FormattedMessage
                    {...messages.CONF_MIRNA_VIEW_ALL_POPUP_SEQUENCE}
                  />
                ) : (
                  <FormattedMessage {...messages.CONF_SEQUENCE_LABEL} />
                )}
              </TableCell>
              <TableCell align="left" className={classes.rootRow}>
                # <FormattedMessage {...messages.CONF_BASES} />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}>
                <FormattedMessage {...messages.CONF_VIEWALL_AMOUNT} />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}>
                <FormattedMessage {...messages.CONF_PURIFICATION} />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}>
                # <FormattedMessage {...messages.CONF_VIEWALL_TUBES} />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderData()}</TableBody>
        </Table>
      </DialogContent>
      <DialogActions className={classes.buttonWrapper}>
        <Grid container spacing={8}>
          <Grid item sm={10}>
            <div>
              <Button
                color="primary"
                variant="contained"
                onClick={handleClose}
                id="delete-close-button"
                data-testid="delete-close-button"
              >
                Close
              </Button>
            </div>
          </Grid>

          <Grid item sm={2}>
            <div>
              <Button
                onClick={() => {
                  setDelDialogOpen(true)
                  setDelType('All')
                }}
                className={classes.deleteAll}
                id="delete-confirm-button"
                data-testid="delete-confirm-button"
              >
                Delete All
              </Button>
            </div>
          </Grid>
        </Grid>
      </DialogActions>
      <div className={classes.delPopup}>
        <DeleteDialog
          dialogOpen={delDialogOpen}
          setDialogOpen={setDelDialogOpen}
          selectedItem={delItem}
          type={delType}
          onDelete={onDelete}
        />
      </div>
    </Dialog>
  )
}

export default ViewAllDialog
